import {css} from 'styled-components';

import {ModalBody} from '../modal-sections/ModalBody';

export const modalSize = (popup, size) => {
    if (popup) {
        if (size === 'md')
            return css`
                @media only screen and (min-width: 1040px) {
                    width: 60%;
                }
            `;
        else if (size === 'sm')
            return css`
                @media only screen and (min-width: 1040px) {
                    width: 840px;
                }
            `;
        else if (size === 'xl')
            return css`
                @media only screen and (min-width: 1040px) {
                    width: 90%;
                }
            `;
        else if (size === 'xl-fixed-height')
            // This size should be used if the modal contains a sidebar, because the sidebar requires the modal to have a fixed height
            // and hidden x-overflow
            return css`
                display: flex;
                flex-direction: column;
                height: 100%;
                overflow-x: hidden;
                ${ModalBody} {
                    flex-grow: 1;
                }
                @media only screen and (min-width: 1040px) {
                    width: 90%;
                }
            `;
        else if (!size)
            return css`
                max-width: var(--modal-default-width);
                width: 100%;
            `;
    }
};
